import { RegionService } from "src/app/services/feature-access-control/region.service";
import { formatCurrency as ngFormatCurrency } from "@angular/common";

export function formatCurrency({
  value,
  regionService
}: {
  value: number;
  regionService: RegionService;
}): string {
  const currency = regionService.getCurrency();
  const currencySymbol = regionService.getCurrencySymbol();
  const locale = regionService.getLocale();

  return ngFormatCurrency(
    value,
    locale,
    currencySymbol + " ",
    currency,
    "1.2-2"
  ).trim();
}
